import { Destination } from "./../../destination/destination.reducer";
import { ApiService } from "./../../../api/api.service";
import { API_CALL_ERROR } from "./../../../store/action";
import {
  call,
  put,
  takeEvery,
  takeLatest,
  fork,
  select
} from "redux-saga/effects";
import * as _ from "lodash";
import { ReflectiveInjector, Injector } from "@angular/core";
import { AppInjector } from "../../../app-injector";
import {
  GET_INVENTORY_DETAIL_REQUESTED,
  GET_INVENTORY_DETAIL_SUCCEEDED,
} from "./detail.action";

function* fetchDestinationLocation(action) {
  // try {
  //   const api = AppInjector.get(ApiService);
  //   let result = yield api.inventory.getInventoryBySku(action.data).toPromise();
  //   yield put({
  //     type: GET_INVENTORY_DETAIL_SUCCEEDED,
  //     data: result
  //   });
  // } catch (e) {
  //   yield put({ type: API_CALL_ERROR, error: e });
  // }
}

function* watchGetInventoryRequested() {
  yield takeEvery(GET_INVENTORY_DETAIL_REQUESTED, fetchDestinationLocation);
}

export default [
  watchGetInventoryRequested,
];
